import { Plane } from 'lucide-react';
import type { RouteItem } from '@/types/routeMap';
import type { RouteColorScale } from './colorScale';

interface RouteStatCardProps {
  route: RouteItem;
  colorScale: RouteColorScale;
}

function formatHours(minutes: number): string {
  if (!minutes || minutes <= 0) return '0h';
  const hours = minutes / 60;
  return hours >= 10 ? `${Math.round(hours)}h` : `${hours.toFixed(1)}h`;
}

export function RouteStatCard({ route, colorScale }: RouteStatCardProps) {
  const color = colorScale(route.count);
  const hasCoords = route.departureCoord && route.arrivalCoord;

  return (
    <div
      className="group relative flex items-center gap-3 rounded-xl bg-white/5 ring-1 ring-white/10 p-3 hover:bg-white/10 hover:ring-cyan-400/30 transition-colors"
      style={{
        boxShadow: hasCoords ? `0 0 0 0 transparent` : undefined,
      }}
    >
      <div
        aria-hidden
        className="w-1 h-10 rounded-full shrink-0"
        style={{
          background: `linear-gradient(to bottom, ${color}, ${color}40)`,
          boxShadow: `0 0 8px ${color}80`,
        }}
      />
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-1.5 font-mono text-sm tracking-wider text-slate-100">
          <span>{route.departure}</span>
          <Plane className="w-3 h-3 text-cyan-300/70" />
          <span>{route.arrival}</span>
          {!hasCoords && (
            <span className="ml-1 text-[10px] font-sans text-amber-400/80">无坐标</span>
          )}
        </div>
        <div className="text-xs text-slate-400 mt-0.5">
          <span className="text-slate-200 font-medium">{route.count}</span> 次
          <span className="mx-1.5 text-slate-600">·</span>
          {formatHours(route.totalMinutes)}
          {route.lastDate && (
            <>
              <span className="mx-1.5 text-slate-600">·</span>
              <span className="text-slate-500">{route.lastDate}</span>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
